import { safeSetItem } from '@/components/shared/SafeSetItem';

export const fetchAndCache = async <T>(
  apiCall: () => Promise<T>,
  apiUrl: string,
  page?: number | string,
): Promise<T> => {
  const cacheKey = page ? `${apiUrl}_page_${page}` : apiUrl;
  const cachedData = localStorage.getItem(cacheKey);
  const expiryDays = process.env.NEXT_PUBLIC_CASH_STORAGE_EXPIRY || 3;

  if (cachedData) {
    try {
      const parsedData = JSON.parse(cachedData);
      const { timestamp, data } = parsedData;
      const now = new Date().getTime();

      if (now - timestamp < Number(expiryDays) * 60 * 60 * 1000) {
        return data;
      }
    } catch (err) {
      console.warn(`Error parsing cached data for key ${cacheKey}`, err);
    }
  }

  const response = await apiCall();

  if (page) {
    const timestamp = new Date().getTime();
    safeSetItem(cacheKey, JSON.stringify({ timestamp, data: response }));
  }

  return response;
};
